import { i18n } from '@/plugins/i18n'

export const shTaxStatus = {
    FINAL_REJECT:5,
    PENDING:8,
    DELAY:12,
    CONFIRMED:14,
    SHAPARAK_PENDING:20
}

export const shTaxStatusStr = {
    FINAL_REJECT: i18n.t('gateway.tax.statuses.final_reject'),
    PENDING: i18n.t('gateway.tax.statuses.pending'),
    CREATED: i18n.t('gateway.tax.statuses.created'),
    DELAY: i18n.t('gateway.tax.statuses.delay'),
    CONFIRMED: i18n.t('gateway.tax.statuses.confirmed'),
    SHAPARAK_PENDING: i18n.t('gateway.tax.statuses.shaparak_pending'),

    get(status) {
        let status_str = null;
        Object.keys(shTaxStatus).forEach(function (item) {
            if(shTaxStatus[item] === status) {
                status_str = shTaxStatusStr[item]
            }
        })

        return status_str
    }
}

export const shTaxVariant = (status) => {
    if(status === shTaxStatus.CONFIRMED)
        return 'success'

    if(status === shTaxStatus.FINAL_REJECT)
        return 'danger'

    if(status === shTaxStatus.PENDING || status === shTaxStatus.DELAY)
        return 'warning'

    return 'info'
}

export const registrationStatus = {
    NO_REGISTRATION: 0,
    HAS_ACTIVE_REGISTRATION: 1,
    HAS_INACTIVE_REGISTRATION: -1,
}

export const registrationStatusStr = {
    NO_REGISTRATION: i18n.t('gateway.tax.registration_statuses.no_registration'),
    HAS_ACTIVE_REGISTRATION: i18n.t('gateway.tax.registration_statuses.has_active_registration'),
    HAS_INACTIVE_REGISTRATION: i18n.t('gateway.tax.registration_statuses.has_inactive_registration'),

    get(status) {
        let status_str = null;
        Object.keys(registrationStatus).forEach(function (item) {
            if(registrationStatus[item] === status) {
                status_str = registrationStatusStr[item]
            }
        })

        return status_str
    }
}